import { ServiceResponse, ServiceResponseNoContent } from "../../../common";
import { CreateFileDto } from "../../dtos/in/createFileDto";
import { UpdateFileDto } from "../../dtos/in/updateFileDto";
import { FileDto } from "../../dtos/out/fileDto";

const IFilesClientId = Symbol("IFilesClient");

interface IFilesClient {

	getFile(fileId: string, accessToken: string): Promise<ServiceResponse<FileDto>>;

	createFile(dto: CreateFileDto, accessToken: string): Promise<ServiceResponse<FileDto>>;

	updateFile(fileId: string, dto: UpdateFileDto, accessToken: string): Promise<ServiceResponse<FileDto>>;

	deleteFile(fileId: string, accessToken: string): Promise<ServiceResponseNoContent>;

	uploadFile(dto: FileDto, file: File, onProgressUpdate): Promise<ServiceResponseNoContent>;

};

export { IFilesClientId, IFilesClient };